import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { LwCheckbox } from './lw-checkbox';

@Injectable({
    providedIn: 'root'
})

export class LwComponentRenderer {
    formOptions: any = null;
    conditions: any = [];
    components:any={}

    constructor(private lwCheckbox:LwCheckbox) { 
        this.components={
            "lw-checkbox":lwCheckbox
        }
    }

    editCondition(conditions:any) {
        this.formOptions["value"] = conditions;
    }
    renderElement(containerId:string, options:any, compile?:any, scope?:any) {

        this.formOptions = options;
        var mainContainer = document.getElementById(containerId);

        var elementContainer = document.createElement("div");
        elementContainer.setAttribute("class", "padding-bottom-0");
        var classToSet = "col col-lg-12 col-md-12 col-sm-12 col-xs-12";

        var componentToRender = document.createElement(_.get(options, "componentToRender"));
        elementContainer.append(componentToRender);
        if(_.get(options, "componentToRender") && this.components[_.get(options, "componentToRender")]){
            const componentName = _.get(options, "componentToRender")
            this.components[componentName].renderElement(containerId,options)
        }
        

        // Below code is only for the ltms-workflow-edit-conditions component
        // Prepopulate values
        if (options["value"]) {
            options["attributes"]["workflow"][options["keyToUpdate"]] = options["value"];
        }

        for (let key in options["attributes"]) {
            if (key == "brand-detail") {
                delete options["attributes"][key]['rules'];
            }
            if (typeof options["attributes"][key] == "function" || options["attributes"][key] == "functionToHandle") {
                // Get the function body as string as setAttribute doesn't accepts function.
                var fn = options["attributes"][key]//('' + options["attributes"][key]).match(/{([^]*)}[^}]*/)[1];
                if (key == "edit-condition-str" || key == "edit-event-str") {
                    fn = this.editCondition //('' + this.editCondition).match(/{([^]*)}[^}]*/)[1];
                }
                componentToRender.setAttribute(key, fn);
            } else {
                componentToRender.setAttribute(key, JSON.stringify(options["attributes"][key]));
            }
        }


        // compile(componentToRender)(scope);


        if (mainContainer)
            mainContainer.appendChild(elementContainer);

    }
}
